import template from './expansion-panel.html';
export var ExpansionPanelComponent = {
    template: template,
    bindings: {
        title: '@'
    },
    transclude: true,
    controller: /** @class */ (function () {
        function ExpansionPanelComponent() {
            'ngInject';
        }
        ExpansionPanelComponent.prototype.$onInit = function () {
            this.open = false;
        };
        ExpansionPanelComponent.prototype.toggle = function () {
            this.open = !this.open;
        };
        return ExpansionPanelComponent;
    }())
};
//# sourceMappingURL=expansion-panel.component.js.map